export enum RowType {
  Select = "select",
  Detail = "detail",
  Toggle = "toggle",
  Default = "default",
}
